(function () {
  'use strict';

  window.DeckauraToolTranslations = Object.assign(window.DeckauraToolTranslations || {}, {
    'Aries': 'Koç',
    'Taurus': 'Boğa',
    'Gemini': 'İkizler',
    'Cancer': 'Yengeç',
    'Leo': 'Aslan',
    'Virgo': 'Başak',
    'Libra': 'Terazi',
    'Scorpio': 'Akrep',
    'Sagittarius': 'Yay',
    'Capricorn': 'Oğlak',
    'Aquarius': 'Kova',
    'Pisces': 'Balık',
    'Aries, Leo, Sagittarius': 'Koç, Aslan, Yay',
    'Taurus, Virgo, Capricorn': 'Boğa, Başak, Oğlak',
    'Gemini, Libra, Aquarius': 'İkizler, Terazi, Kova',
    'Cancer, Scorpio, Pisces': 'Yengeç, Akrep, Balık',
    'Moon Phase Today': 'Bugünkü Ay Evresi',
    '🌙 Moon Phase Today': '🌙 Bugünkü Ay Evresi',
    'Sep': 'Eyl',
    'September': 'Eylül'
  });
})();
